<template>
  <div id="skip">
    <span v-if="countdown > 0">{{countdown}} {{ $t("CONTENT.AD") }}</span>
    <span v-else-if="loaded" v-on:click="skip()">
      {{ $t("CONTENT.AD-SKIP") }}
      <icon name="step-forward" :scale="1.2"></icon>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AdCounter',
  props: ['timeout'],
  data () {
    return {
      loaded: false,
      countdown: 0,
      counter: 0,
      interval: null
    }
  },
  created: function () { this.countdown = this.timeout },
  mounted () {
    this.interval = setInterval(() => {
      this.counter++
      this.loaded = true
      this.countdown = Math.ceil(this.timeout - this.counter)
      if (this.countdown < 0) {
        clearInterval(this.interval)
        this.$emit('endAdTime')
      }
    }, 1000)
  },
  methods: {
    skip () { clearInterval(this.interval); this.$emit('skip') }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#skip
  position: absolute
  right: 1rem
  bottom: 10vh
  font-size: 2.6rem
  font-weight: bold
  color: white
  padding: 0 1vw
  cursor: pointer
  background-color: rgba(0, 0, 0, 0.5)
  z-index: 1

</style>



// WEBPACK FOOTER //
// src/components/AdCounter.vue